import { render, staticRenderFns } from "./RHIdiomas.vue?vue&type=template&id=e2b017da&scoped=true"
import script from "./RHIdiomas.vue?vue&type=script&lang=js"
export * from "./RHIdiomas.vue?vue&type=script&lang=js"
import style0 from "./RHIdiomas.vue?vue&type=style&index=0&id=e2b017da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b017da",
  null
  
)

export default component.exports